<ion-card>
    <ion-item>
        <ion-label position="floating">Order Number</ion-label>
        <ion-input [(ngModel)]="document.orderNumber" [disabled]="document.parentDocument"></ion-input>
    </ion-item>
</ion-card>
